import WtDetailDialog from './src/component'

/* istanbul ignore next */
WtDetailDialog.install = function(Vue) {
  Vue.component(WtDetailDialog.name, WtDetailDialog)
}

export default WtDetailDialog
